<template>

  <div class="container" id="faqContainer">
    <h2 class="light dark mb-30">Häufig gestellte <span class="bold">Fragen</span></h2>

    <div id="accordion" class="mt-4 mb-4">

    <template v-for="(item, index) in collection"  >
      <div class="card mb-1"  v-if="!item.hide" :key="item._id">
          <div class="card-header" :id="'heading' + index" >
            <div class="mb-0">
              <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse' + index" aria-expanded="true" :aria-controls="'collapse' + index">
                {{item.question}}
              </button>
            </div>
          </div>

          <div :id="'collapse' + index" class="collapse" :aria-labelledby="'heading' + index" data-parent="#accordion">
            <div class="card-body" v-html="item.answer" />
          </div>
        </div>
    </template>

    </div>

  </div>

</template>

<script>
    export default {
        components:{

        },
        data() {
            return {
              collection:[],
            }
        },
        mounted () {
          this.$http.get(this.$store.getters.serviceClient().getCollectionUrl('contentFAQ'))
            .then((response) => {
              if (response.ok) {
                console.log(response.body.entries)
                this.$data.collection = response.body.entries
              }
            })
            .catch((error) => {
              console.log(error)
            });

            $('#accordion').on('shown.bs.collapse', function () {
              var panel = $(this).find('.show');
              $('html, body').animate({
                    scrollTop: panel.offset().top - 150
              }, 500);
            });
        },
        props: [],
        computed: {},
        methods: {}
    }

</script>

<style scoped="scoped">
  #faqContainer{
    color:#666;
    padding-top:5em;
  }

  .card-header{
    padding-top:0.5rem;
    padding-bottom: 0.5rem;
    background-color: rgba(250, 250, 255, 1);
  }

  .card-header *{
      /*color: #009ADF;*/
      font-weight: bold;
      /*color:hsla(263.72, 15.83%, 31.06%, 1)!important;*/
  }

  .card-header button{
      text-align: left!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Faq.vue